export default __webpack_public_path__ + "static/media/earth.69abe327.svg";